/* Copyright (c) 2018 Backpack Health LLC */
import * as React from 'react';

import { ScrollAwareItem } from '../../components/ScrollAware';
import ContentWrapper from '../../components/ContentWrapper';
import { FormattedMessage } from 'react-intl';
import { SurveyPageLayout } from './SurveyQuestion/components/SurveyPageLayout';
import RouteNames from '../../appAuthorized/RouteNames';
import GroupTitle from '../../features/GroupTitle/GroupTitle.presenter';
import { AnsweredSections } from './components/AnsweredSections';
import DateUtil from '../../../utilities/DateUtil';
import PreformattedText from '../../components/PreformattedText';
import { useSurveyForActiveProfile, useSurveyDefinitionQuestionsForActiveProfile } from '../../hooks/useSurvey';
import { useUIState } from '../../hooks/useUIState';
import { useNavigate } from '../../hooks/useNavigate';

interface Props {
  match: any;
}

export const SurveyComplete: React.FC<Props> = (props) => {
  const groupId = Number(props.match.params.groupId);
  const surveyId = Number(props.match.params.surveyId);

  const [, uiActions] = useUIState();
  const [, navActions] = useNavigate();
  const [surveyData] = useSurveyForActiveProfile(surveyId);
  const { survey, definition } = surveyData;
  const surveyDefId = survey.survey_definition_id;

  const [surveyQuestionDefData] = useSurveyDefinitionQuestionsForActiveProfile(surveyDefId);
  const isLoaded = surveyQuestionDefData.isLoaded && surveyData.isLoaded;

  React.useEffect(() => {
    uiActions.setActiveGroup(groupId);
  }, []);

  if (!isLoaded) return null;

  return (
    <SurveyPageLayout
      className="bkgd-color-csAppBGgray"
      navButtons={{
        done: () => {
          navActions.goTo(RouteNames.surveys(groupId));
        },
      }}
      groupId={groupId}
      progress={
        <ScrollAwareItem>{({ displayTitle }) => !!displayTitle &&
          <div className="font-caption-1 theme-group base color" style={{ fontWeight: 'bold' }}>{definition.name}</div>}
        </ScrollAwareItem>}
      mainTitle={
        <div>
          <div className="font-caption-1 theme-group base color">
            <GroupTitle
              groupId={groupId}
              size="48"
            />
          </div>

          <div className="font-title-2 theme-group base color" style={{ paddingTop: 8 }}>
            {definition.name}
          </div>
        </div>
      }
      extendedHeader={() => (
        <PreformattedText className="font-body">
          {definition.short_description}
        </PreformattedText>
      )}
    >
      <ContentWrapper>
        <div className="cmp-scrollaware__content">
          <AnsweredSections survey={survey} />
        </div>

        <div className="util-application-frame-forcards-padding font-caption font-color-gsMedDark" style={{ paddingTop: 24, paddingBottom: 24 }}>
          <FormattedMessage id="ui-data.surveys.completedDate.text" values={{ string1: DateUtil.formattedMediumDate(survey.submitted_at) }} />
        </div>
      </ContentWrapper>
    </SurveyPageLayout>
  );
};
